/* NOMI v23.84 — One in six: stamp each free entry with its entry week (Monday to Sunday, Pacific time),
   so the weekly draw knows which roll it belongs to. */
(function () {
  var form = document.getElementById('ois-free-entry');
  if (!form) return;
  function weekOf(d) {
    var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'short' }).formatToParts(d);
    var p = {}; parts.forEach(function (x) { p[x.type] = x.value; });
    var idx = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].indexOf(p.weekday);
    var local = new Date(Date.UTC(+p.year, +p.month - 1, +p.day));
    local.setUTCDate(local.getUTCDate() - idx);
    return local.toISOString().slice(0, 10);
  }
  form.addEventListener('submit', function () {
    var wk = weekOf(new Date());
    var w = form.querySelector('[data-ois-week]'); if (w) w.value = 'Week of Monday ' + wk + ' (PT)';
    var b = form.querySelector('[data-ois-body]'); if (b) b.value = 'Free entry for the NOMI One in six roll, week of Monday ' + wk + ' (PT). No purchase.';
  });
})();
